import { useEffect, useState } from "react";
import {
  LuArrowRight,
  LuCheckCircle,
  LuCircleEllipsis,
  LuFileSpreadsheet,
  LuFileWarning,
  LuLibrary,
} from "react-icons/lu";
import { Link } from "react-router-dom";
import apiClient from "../../../api-services/ApiClient";
import BarChartComponent from "../../../app-components/charts/BarChart";
import Preloader from "../../../app-components/preloader/Preloader";
import { SITELINKS } from "../../../app-routes/links";
import { formatDate } from "../../../helpers";
import { ParamInterface } from "../../../interface-and-types";

const AdminDashbaord = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [totalInspections, setTotalInspections] = useState<number>(0);
  const [unsatistactoryActions, setUnsatistactoryActions] = useState<number>(0);
  const [openActions, setOpenActions] = useState<number>(0);
  const [closedOutActions, setClosedOutActions] = useState<number>(0);
  const [overdueActions, setOverdueActions] = useState<number>(0);
  const [actionTrackerCount, setActionTrackerCount] = useState<number>(0);
  const [formStats, setFormStats] = useState<any>([]);
  const [openPriority, setOpenPriority] = useState<any>([]);
  const [inspectionForm, setInspectionForm] = useState<any[]>([]);

  useEffect(() => {
    getTotalVesselInspectionsCount();
    getRejectedActionSummaryCount();
    getOpenActionSummaryCount();
    getClosedActionSummaryCount();
    getOverdueActionsSummaryCount();
    getRateOfClosureOfNewDefects();
    getAverageTimeToCloseOutActionsInDays();
    getActionTrackerCount();
    getActionTrackerReport();

    setFormStats([]);
  }, []);

  useEffect(() => {
    const params = {
      page: 1,
      SearchString: "",
      OrderBy: "Descending",
      VesselName: "",
      InspectionType: "",
      PageSize: 5,
    };

    getInspectionForm(params);
  }, []);

  const getOpenActionSummaryCount = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get(
        "ActionTrackerReport/OpenActionsSummaryCount"
      );

      setOpenActions(res?.data?.data?.count);
      setOpenPriority(res?.data?.data?.openActions);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getActionTrackerReport = async (year: string = "2025") => {
    setLoading(true);
    try {
      const res = await apiClient.get(
        `ActionTrackerReport/OpenedClosedActionSummary?Year=${year}`
      );

      setFormStats(res?.data?.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getActionTrackerCount = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get("ActionTrackerReport/ActionTrackerCount");

      setActionTrackerCount(res?.data?.data?.count);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getTotalVesselInspectionsCount = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get(
        "ActionTrackerReport/TotalVesselInspectionsCount"
      );

      setTotalInspections(res?.data?.data?.count);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getRejectedActionSummaryCount = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get(
        "ActionTrackerReport/ClosedOutActionsSummaryCount?CloseOutAction=2"
      );

      setUnsatistactoryActions(res?.data?.data?.count);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getClosedActionSummaryCount = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get(
        "ActionTrackerReport/ClosedOutActionsSummaryCount"
      );

      setClosedOutActions(res?.data?.data?.count);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getOverdueActionsSummaryCount = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get(
        "ActionTrackerReport/OverdueActionsSummaryCount"
      );

      setOverdueActions(res?.data?.data?.count);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getRateOfClosureOfNewDefects = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get(
        "ActionTrackerReport/RateOfClosureOfNewDefects"
      );

      console.log(res);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getAverageTimeToCloseOutActionsInDays = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get(
        "ActionTrackerReport/AverageTimeToCloseOutActionsInDays"
      );

      console.log(res);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getInspectionForm = async (params: ParamInterface) => {
    setLoading(true);
    try {
      const res: any = await apiClient.get("InspectionForm", { params });
      if (res && res.data) {
        setInspectionForm(res.data.data);
      } else {
        setInspectionForm([]);
      }
    } catch (error) {
      console.error("Error fetching Inspection Form:", error);
      setInspectionForm([]);
    } finally {
      setLoading(false);
    }
  };

  const getOpenPriorityPercent = (
    allPriority: any,
    currentOpenAction: number,
    action: string
  ) => {
    const actionValue = allPriority?.find(
      (item: any) => item.priority === action
    )?.count;

    const percentagePriority = (actionValue / currentOpenAction) * 100;

    return percentagePriority ? `${percentagePriority ?? 0}%` : "0%";
  };

  return (
    <>
      <section className="flex justify-between items-center bg-gradient-to-r from-secondaryBlue to-primaryBlue shadow-md border-b border-gray-200">
        <div className="xl:container xl:mx-auto md:px-4 py-4 pb-24 flex justify-between items-center">
          <h4 className="lg:text-[16px] text-white nunito font-medium">
            Administrator Dashboard
          </h4>
        </div>
      </section>

      <section className="pt-5 mx-auto md:px-4 xl:container relative top-[-100px] xl:top-[-105px]">
        <div className="xl:flex gap-4">
          <div className="flex gap-4 w-full">
            <div className="xl:w-4/6 md:w-full">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
                {/* count card 1 */}
                <div className="rounded-lg bg-white hover:shadow-xl shadow-sm border p-4 2xl:p-6 flex-col gap-2">
                  <div>
                    <LuFileSpreadsheet className="p-3 bg-[#f93185] rounded-full shadow text-white text-[50px]" />
                  </div>
                  <p className="text-sm mt-2">Total Inspections</p>
                  <h3 className="text-2xl font-medium mt-2">
                    {totalInspections}
                  </h3>
                </div>

                {/* count card 2 */}
                <div className="rounded-lg bg-white hover:shadow-xl shadow-sm p-4 2xl:p-6 flex-col gap-2 border">
                  <div>
                    <LuFileWarning className="p-3 bg-[#ff5151] rounded-full shadow text-white text-[50px]" />
                  </div>
                  <p className="text-sm mt-2">Rejected Actions</p>
                  <h3 className="text-2xl font-medium mt-2">
                    {unsatistactoryActions}
                  </h3>
                </div>

                {/* count card 3 */}
                <div className="rounded-lg bg-white hover:shadow-xl shadow-sm border p-4 2xl:p-6 flex-col gap-2">
                  <div>
                    <LuCircleEllipsis className="p-3 bg-[#c1a513] rounded-full shadow text-white text-[50px]" />
                  </div>
                  <p className="text-sm mt-2">Overdue Actions</p>
                  <h3 className="text-2xl font-medium mt-2">
                    {overdueActions}
                  </h3>
                </div>

                {/* count card 4 */}
                <div className="rounded-lg bg-white hover:shadow-xl shadow-sm border p-4 2xl:p-6 flex-col gap-2">
                  <div>
                    <LuCheckCircle className="p-3 bg-[#09b405] rounded-full shadow text-white text-[50px]" />
                  </div>
                  <p className="text-sm mt-2">Closed-Out Actions</p>
                  <h3 className="text-2xl font-medium mt-2">
                    {closedOutActions}
                  </h3>
                </div>
              </div>
            </div>

            {/* dashboard progress card */}
            <div className="xl:w-2/6 md:w-3/6 rounded-lg bg-white hover:shadow-xl shadow p-4 2xl:p-6 relative">
              <div>
                <LuFileSpreadsheet className="p-3 bg-[#0338f4] rounded-full shadow text-white text-[50px]" />
              </div>

              <p className="text-sm mt-2">Open Actions</p>
              <h3 className="text-2xl font-medium mt-2">
                {openActions} of {actionTrackerCount}
              </h3>

              <div className="mt-2 pt-6">
                <div className="flex justify-between">
                  <p className="text-xs font-medium">P0</p>
                  <p className="text-[10px] font-medium">
                    {openPriority?.find((item: any) => item.priority === "P0")
                      ?.count ?? 0}
                    /{openActions}
                  </p>
                </div>

                <div className="h-2 w-full bg-neutral-200 dark:bg-neutral-600 rounded-xl">
                  <div
                    className="h-2 bg-[#7fca60]  rounded-xl"
                    style={{
                      width: getOpenPriorityPercent(
                        openPriority,
                        openActions,
                        "P0"
                      ),
                    }}
                  ></div>
                </div>
              </div>

              <div className="mt-2">
                <div className="flex justify-between">
                  <p className="text-xs font-medium">P1</p>
                  <p className="text-[10px] font-medium">
                    {openPriority?.find((item: any) => item.priority === "P1")
                      ?.count ?? 0}
                    /{openActions}
                  </p>
                </div>

                <div className="h-2 w-full bg-neutral-200 dark:bg-neutral-600 rounded-xl">
                  <div
                    className="h-2 bg-[#7fca60]  rounded-xl"
                    style={{
                      width: getOpenPriorityPercent(
                        openPriority,
                        openActions,
                        "P1"
                      ),
                    }}
                  ></div>
                </div>
              </div>

              <div className="mt-2">
                <div className="flex justify-between">
                  <p className="text-xs font-medium">P2</p>
                  <p className="text-[10px] font-medium">
                    {openPriority?.find((item: any) => item.priority === "P2")
                      ?.count ?? 0}
                    /{openActions}
                  </p>
                </div>
                <div className="h-2 w-full bg-neutral-200 dark:bg-neutral-600 rounded-xl">
                  <div
                    className="h-2 bg-[#7fca60]  rounded-xl"
                    style={{
                      width: getOpenPriorityPercent(
                        openPriority,
                        openActions,
                        "P2"
                      ),
                    }}
                  ></div>
                </div>
              </div>

              <div className="mt-2">
                <div className="flex justify-between">
                  <p className="text-xs font-medium">P3</p>
                  <p className="text-[10px] font-medium">
                    {openPriority?.find((item: any) => item.priority === "P3")
                      ?.count ?? 0}
                    /{openActions}
                  </p>
                </div>
                <div className="h-2 w-full bg-neutral-200 dark:bg-neutral-600 rounded-xl">
                  <div
                    className="h-2 bg-[#7fca60]  rounded-xl"
                    style={{
                      width: getOpenPriorityPercent(
                        openPriority,
                        openActions,
                        "P3"
                      ),
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full rounded-xl bg-white shadow hover:shadow-xl p-4 2xl:p-6 md:mt-4 xl:mt-0">
            <div className="flex justify-between items-center">
              <p className="text-sm">Average time taken to close actions</p>
              <select
                className="border px-3 rounded text-xs p-1 shadow-sm"
                onChange={(e) => getActionTrackerReport(e.target.value)}
              >
                <option value="2025">2025</option>
              </select>
            </div>

            <BarChartComponent data={formStats} />
          </div>
        </div>

        <div className="flex gap-4 mt-4 min-h-[280px]">
          <div className="w-full rounded-xl bg-white shadow-sm hover:shadow-xl">
            <div className="flex justify-between p-4 2xl:p-6">
              <p className="text-sm">Recent Inspections</p>
              <select className="border px-3 rounded text-xs p-1 shadow-sm hidden">
                <option>Download</option>
              </select>
            </div>

            {/* record TABLE */}
            <div className="overflow-x-auto mb-5 overflow-y-auto">
              <table className="min-w-full bg-white mb-4">
                <thead>
                  <tr className="w-full bg-slate-200 text-slate-600 capitalize text-xs leading-normal border-b">
                    <th className="py-1 px-3 pl-6 text-left font-medium align-top">
                      Vessel name
                    </th>
                    <th className="py-1 px-3 text-left font-medium align-top">
                      IMO nos.
                    </th>
                    <th className="py-1 px-3 text-left font-medium align-top">
                      Date
                    </th>
                    <th className="py-1 px-3 text-left font-medium align-top">
                      Status
                    </th>
                    <th className="py-1 px-3 text-left font-medium align-top">
                      Marine Superintendent
                    </th>
                    <th className="py-1 px-3 text-left font-medium align-top">
                      Place of inspection
                    </th>
                    <th className="py-1 px-3 text-left font-medium align-top">
                      Type of inspection
                    </th>
                    <th className="py-1 px-3 text-left font-medium align-top">
                      Actions
                    </th>
                  </tr>
                </thead>

                {!!inspectionForm?.length && (
                  <tbody className="text-[#111827] text-xs font-light">
                    {inspectionForm?.map((inspection: any, i: number) => {
                      return (
                        <tr
                          key={inspection.id}
                          className={`border-b border-[#F2F1F1] hover:bg-gray-100 font-normal text-[#232630] even:bg-gray-50`}
                        >
                          <td className="py-2 px-3 pl-6 text-left">
                            {inspection?.vessel?.name ?? ""}
                          </td>

                          <td className="py-2 px-3 text-left">
                            {inspection?.vessel?.imoNumber ?? ""}
                          </td>

                          <td className="py-2 px-3 text-left">
                            {inspection?.dateOfInspection
                              ? formatDate(inspection?.dateOfInspection, "date")
                              : ""}
                          </td>

                          <td className="py-2 px-3 text-left">
                            {inspection?.formState ?? ""}
                          </td>

                          <td className="py-2 px-3 text-left">
                            {inspection?.user?.firstName ?? ""}{" "}
                            {inspection?.user?.lastName ?? ""}
                          </td>

                          <td className="py-2 px-3 text-left">
                            {inspection?.placeOfInspection ?? ""}
                          </td>

                          <td className="py-2 px-3 text-left">
                            {inspection?.inspectionType?.name ?? ""}
                          </td>

                          <td className="py-2 px-2 text-left flex gap-4 items-left">
                            {inspection?.inspectionType?.name.toLowerCase() ===
                            "suitability" ? (
                              <Link
                                to={`${SITELINKS.ASSESSMENT_FORM}/${inspection?.id}`}
                                className={`font-medium flex gap-1 items-center text-red-600 hover:text-blue-800`}
                              >
                                <span>Suitability Form</span>
                                <LuArrowRight />
                              </Link>
                            ) : (
                              <Link
                                to={`${SITELINKS.INSERVICE_ASSESSMENT_FORM}/${inspection?.id}`}
                                className={`font-medium flex gap-1 items-center text-red-600 hover:text-blue-800`}
                              >
                                <span>In-Service Form</span>
                                <LuArrowRight />
                              </Link>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                )}
              </table>

              {!inspectionForm?.length && (
                <div className="text-center p-16 text-sm text-gray-500 ">
                  <LuLibrary className="text-[50px] w-full" />
                  <p> No record</p>
                </div>
              )}
            </div>
          </div>
        </div>

        <Preloader loading={loading} />
      </section>
    </>
  );
};

export default AdminDashbaord;
